<template>
  <div class="rt-list-filter">
    <slot />
    <div class="filter-btns"><slot name="btns" /></div>
  </div>
</template>

<script>
export default {
  name: 'RtListFilter'
};
</script>

<style lang="less">
.rt-list-filter {
  border-top: 1px solid #e8e8e8;
  position: relative;
  background: #fff;
  padding: 0 20px 20px;
  .filter-btns {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// rtListFilter.vue?3b9f4a20